/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FeatureDto } from './featureDto';

export interface WonderDto { 
    uuid?: string;
    name?: string;
    names?: { [key: string]: string; };
    descriptions?: { [key: string]: string; };
    features?: Array<FeatureDto>;
    type?: WonderDto.TypeEnum;
    cost?: number;
    discountedTechnology?: string;
    discountedCost?: number;
    obsoleted?: boolean;
}
export namespace WonderDto {
    export type TypeEnum = 'Ancient' | 'Medieval' | 'Modern';
    export const TypeEnum = {
        Ancient: 'Ancient' as TypeEnum,
        Medieval: 'Medieval' as TypeEnum,
        Modern: 'Modern' as TypeEnum
    };
}